import { lazy, Suspense } from 'react'

import { CardCustomizationBlocker } from '@cash-web/protos/squareup/franklin/blockers/card_customization_blocker.pb'

const CardStudio = lazy(() =>
  import('@cash-web/shared-card-studio-feature-main').then(module => ({ default: module.CardStudio }))
)

export const BlockerCardCustomization = ({ blocker }: { blocker: CardCustomizationBlocker }) => {
  return (
    <Suspense fallback={null}>
      <CardStudio blocker={blocker} />
    </Suspense>
  )
}
